import React from "react";
import { Popup } from "semantic-ui-react";
import "../styles/AgentRequestStatus.css";

const STATUS_CONFIG = {
  in_progress: { label: "In Progress", title: "Live agent request is in progress" },
  joined: { label: "Joined", title: "A live agent has joined the chat" },
  failed: { label: "Failed", title: "The live agent request failed" },
};

// Read-only badge that shows the state of the live agent request.
// status: "in_progress" | "joined" | "failed" | null (nothing is rendered)
const AgentRequestStatus = ({ status }) => {
  const config = STATUS_CONFIG[status];
  if (!config) return null;

  return (
    <Popup
      content={config.title}
      inverted
      position="bottom center"
      style={{ borderRadius: "15px" }}
      trigger={
        <div
          className={`agent-request-status agent-request-status-${status}`}
          role="status"
          data-cy="agent-request-status-cy"
        >
          <span className="agent-request-status-dot" />
          <span className="agent-request-status-label">Live Agent: {config.label}</span>
        </div>
      }
    />
  );
};

export default AgentRequestStatus;
